"use strict";
import * as dom from "./lib/dom.js";

export default function () {
    // select the target node
    var target = document.getElementById("mce-success-response");
    // create an observer instance
    var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            if (target.innerHTML === "Thank you for subscribing!") {
                target.innerHTML = "Obrigado por se inscrever!";
            }
            if (
                target.innerHTML ===
                "You're already subscribed, your profile has been updated. Thank you!"
            ) {
                target.innerHTML =
                    "Você já está inscrito, seu perfil foi atualizado. Obrigado!";
            }
        });
    });

    // configuration of the observer:
    var config = { attributes: true, childList: true, characterData: true };

    // pass in the target node, as well as the observer options
    observer.observe(target, config);
}
